import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { RouteAdapter } from "RouteAdapter";
import ProfilesConfigViews from "views/Config/Profiles";
import VerifiedSubcriberDetail from "views/Statistics/SubscriberDetail/component";
import {SubscriberGroupsAndDashboard} from "views/Status/SubscriberGroups/SubscriberGroupsAndDashboard";
import {SubscribersAndDetails} from "views/Status/Subscribers/SubscribersAndDetails";
import SubscriberGroupDashboard from "views/Statistics/SubscriberGroupDashboard/component";
import ThroughputAndDashboard from "views/Status/SubscriberThroughputLive/ThroughputAndDashboard";
import BtaTraffic from "views/Statistics/Throughput/BtaTraffic/component";
import SubscriberFlows from "views/Config/SubscriberFlows/Tabs/component";
import SubscriberRates from "views/Config/SubscriberRates/Tabs/component";
import SubscriberMonitor from "views/Config/SubscriberMonitoring/Tabs/component";
import Interfaces from "views/Statistics/Throughput/Interfaces/component";
import TCPOComparison from "views/Status/TCPOComparison/component";
import FlowsPerLPolicyHourly from "views/Statistics/Flows/PerPolicy/component";
import RatePolicies from "views/Status/Policies/Rate/component";
import {PoliciesList as FlowPolicies} from "views/Status/Policies/Flow/component";
import {PoliciesList as MonitoringPolicies} from "views/Status/Policies/Monitoring/component";
import FlowsPerSubscriber from "views/Status/Flows/PerSubscriber/component";
import FlowsPerProtocolStatus from "views/Status/Flows/PerProtocol/component";
import LoginContainer from "views/Login/component";
import SubscriberQuotas from "views/Status/SubscriberQuotas/component";
import SubscriberAttributes from "views/Status/SubscriberAttributes/component";
import BillingStatus from "views/Status/Billing/component";
import SubcriberDetail from "views/Statistics/Congestion/CongestionAndACM/component";
import {TCPOComparison as SpeedTCPOComparison} from "views/Statistics/TCPOptimization/Speed/component"
import {TCPOComparison as AccelerationTCPOComparison} from "views/Statistics/TCPOptimization/Acceleration/component"
import ProtocolsThroughput from "views/Statistics/Throughput/Protocols/component";
import PoliciesThroughputView from "views/Statistics/Throughput/PerPolicy/component";
import ProfileContext from "common/ProfileContext";
import DoSVolumeStats from "views/Statistics/DoS/Volume/component";
import DoSSynStats from "views/Statistics/DoS/Syn/component";
import DoSOverTimeStats from "views/Statistics/DoS/OverTime/component";
import DPIHourlyVolume from "views/Statistics/DPI/HourlyVolume/component";
import DPITotalVolume from "views/Statistics/DPI/TotalVolume/component";
import DPILatency from "views/Statistics/DPI/Latency/component";
import SubscribersHourlyVolume from "views/Statistics/Subscribers/HourlyVolume/component";
import SubscribersTotalVolume from "views/Statistics/Subscribers/TotalVolume/component";
import PerPolicySubscribersView from "views/Statistics/Subscribers/PerPolicy/component";
import FlowsPerProtocol from "views/Statistics/Flows/PerProtocol/component";
import SysStatsCpu from "views/Statistics/System/SysStatsCpu/component";
import SysStatsMem from "views/Statistics/System/SysStatsMem/component";
import StatsLatency from "views/Statistics/System/StatsLatency/component";
import StatsRtx from "views/Statistics/System/StatsRtx/component";
import RESTConfig from "views/Config/REST/component";
import RADIUSConfig from "views/Config/RADIUS/component";
import OptimizationConfig from "views/Config/Optimization/component";
import DoSConfig from "views/Config/DoS/component";
import ManagementInterfaceConfig from "views/Config/Interfaces/Management/component";
import ManagementFirewallConfig from "views/Config/Interfaces/Firewall/component";
import BackupSave from "views/Administration/Backup/Save/component";
import ThroughputStatus from "views/Status/Interfaces/Throughput/component";
import LinkState from "views/Status/Interfaces/LinkState/component";
import DataWiresConfig from "views/Config/Interfaces/DataWires/component";
import AdminSNMP from "views/Administration/SNMPView/component";
import KernelLogs from "views/Administration/Logs/Kernel/component";
import SystemLogs from "views/Administration/Logs/System/component";
import BackupLoadView from "views/Administration/Backup/Load/component";
import GeneralSettings from "views/Administration/GeneralSettings/component";
import ClusterConfiguration from "views/Administration/Cluster/Configuration/ClusterConfiguration";
import UsersAdmin from "views/Administration/Users/component";
import Software from "views/Administration/Software/component";
import PolicyFlowEdit from "views/Config/SubscriberFlows/PolicyEdit/PolicyFlowEdit";
import PolicyMonitorEdit from "views/Config/SubscriberMonitoring/PolicyMonitorEdit";
import PolicyRateEdit from "views/Config/SubscriberRates/PolicyEdit/PolicyRateEdit";
import SystemInformation from "views/Status/System/SystemInformation/SystemInformation";
import { DashboardSwitch } from "views/Dashboard/DashboardSwitch";
import { ClusterDashboard } from "views/ClusterDashboard/ClusterDashboard";
import License from "views/Administration/License/component";
import Bypass from "views/Status/Interfaces/Bypass/Bypass";
import SubscriberGroupEdit from "views/Status/SubscriberGroupsEdit/component";
import StatusSystemRoutes from "views/Status/System";
import SystemDateAdministrationViews from "views/Administration/SystemDate";
import ApplicationMetrics from "views/Statistics/DPI/ApplicationMetrics/ApplicationMetrics";
import HTTPCompressionHourlyVolumeAndRatio from "views/Statistics/HTTPCompression/HourlyVolumeAndRatio/component";
import SaveSubsAttributes from "views/Administration/Backup/SaveSubsAttributes/component";
import LoadSubsAttributes from "views/Administration/Backup/LoadSubsAttributes/component";
import ContextEditor from "views/Context/component";

const asAdaptedRoute = ({ path, view }) => (
  <Route key={path} path={path} element={<RouteAdapter Component={view} />} />
);

export function AppRoutes() {
  const profile = useContext(ProfileContext);

  if (profile === null) {
    return (
      <Routes>
        <Route
          path="/viewLogin"
          element={<RouteAdapter Component={LoginContainer} />}
        />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route
        path="/viewIfaceStkStats"
        element={<RouteAdapter Component={Interfaces} />}
      />
      <Route
        path="/viewBtaStatsTraffic"
        element={<RouteAdapter Component={BtaTraffic} />}
      />
      <Route
        path="/viewStatusSubscribers"
        element={<RouteAdapter Component={SubscribersAndDetails} />}
      />
      <Route
        path="/viewSubscriberThroughput"
        element={<RouteAdapter Component={ThroughputAndDashboard} />}
      />
      <Route
        path="/viewSubsDetail"
        element={<RouteAdapter Component={VerifiedSubcriberDetail} />}
      />
      <Route
        path="/viewStatusSubscriberGroups"
        element={<RouteAdapter Component={SubscriberGroupsAndDashboard} />}
      />
      <Route
        path="/viewSubscriberGroupDashboard"
        element={<RouteAdapter Component={SubscriberGroupDashboard} />}
      />
      <Route
        path="/viewStatusSubscriberGroupsEdit"
        element={<RouteAdapter Component={SubscriberGroupEdit} />}
      />
      <Route
        path="/viewStatusTCPO"
        element={<RouteAdapter Component={TCPOComparison} />}
      />
      <Route
        path="/viewFlowsPerPolicy"
        element={<RouteAdapter Component={FlowsPerLPolicyHourly} />}
      />
      <Route
        path="/viewRatePolicies"
        element={<RouteAdapter Component={RatePolicies} />}
      />
      <Route
        path="/viewFlowPolicies"
        element={<RouteAdapter Component={FlowPolicies} />}
      />
      <Route
        path="/viewMonitoringPolicies"
        element={<RouteAdapter Component={MonitoringPolicies} />}
      />
      <Route
        path="/viewFlowsPerSubs"
        element={<RouteAdapter Component={FlowsPerSubscriber} />}
      />
      <Route
        path="/viewFlowsPerProtocol"
        element={<RouteAdapter Component={FlowsPerProtocolStatus} />}
      />
      <Route
        path="/viewSubscriberQuotas"
        element={<RouteAdapter Component={SubscriberQuotas} />}
      />
      <Route
        path="/viewSubscriberAttributes"
        element={<RouteAdapter Component={SubscriberAttributes} />}
      />
      <Route
        path="/viewLicense"
        element={<RouteAdapter Component={License} />}
      />
      {StatusSystemRoutes.map(asAdaptedRoute)}
      <Route
        path="/viewStatusSystemInformation"
        element={<RouteAdapter Component={SystemInformation} />}
      />
      <Route
        path="/viewStatusBilling"
        element={<RouteAdapter Component={BillingStatus} />}
      />
      <Route
        path="/viewCongestionACM"
        element={<RouteAdapter Component={SubcriberDetail} />}
      />
      <Route
        path="/viewTCPOptimizationSpeed"
        element={<RouteAdapter Component={SpeedTCPOComparison} />}
      />
      <Route
        path="/viewTCPOptimizationAcceleration"
        element={<RouteAdapter Component={AccelerationTCPOComparison} />}
      />
      <Route
        path="/viewThroughputProtocols"
        element={<RouteAdapter Component={ProtocolsThroughput} />}
      />
      <Route
        path="/viewThroughputPerPolicy"
        element={<RouteAdapter Component={PoliciesThroughputView} />}
      />
      <Route
        path="/viewDosStatsTime"
        element={<RouteAdapter Component={DoSOverTimeStats} />}
      />
      <Route
        path="/viewDoSVolumeStats"
        element={<RouteAdapter Component={DoSVolumeStats} />}
      />
      <Route
        path="/viewDoSSynStats"
        element={<RouteAdapter Component={DoSSynStats} />}
      />
      <Route
        path="/viewDPIHourlyVolume"
        element={<RouteAdapter Component={DPIHourlyVolume} />}
      />
      <Route
        path="/viewHTTPCompressionHourlyVolumeAndRatio"
        element={
          <RouteAdapter Component={HTTPCompressionHourlyVolumeAndRatio} />
        }
      />
      <Route
        path="/viewDPITotalVolume"
        element={<RouteAdapter Component={DPITotalVolume} />}
      />
      <Route
        path="/viewDPILatency"
        element={<RouteAdapter Component={DPILatency} />}
      />
      <Route
        path="/viewDPIServiceMetrics"
        element={<RouteAdapter Component={ApplicationMetrics} />}
      />
      <Route
        path="/viewSubscribersHourlyVolume"
        element={<RouteAdapter Component={SubscribersHourlyVolume} />}
      />
      <Route
        path="/viewSubscribersTotalVolume"
        element={<RouteAdapter Component={SubscribersTotalVolume} />}
      />
      <Route
        path="/viewSubscribersPerPolicy"
        element={<RouteAdapter Component={PerPolicySubscribersView} />}
      />
      <Route
        path="/viewBtaStatsSess"
        element={<RouteAdapter Component={FlowsPerProtocol} />}
      />
      <Route
        path="/viewSysStatsCpu"
        element={<RouteAdapter Component={SysStatsCpu} />}
      />
      <Route
        path="/viewSysStatsMem"
        element={<RouteAdapter Component={SysStatsMem} />}
      />
      <Route
        path="/viewLatencyStats"
        element={<RouteAdapter Component={StatsLatency} />}
      />
      <Route
        path="/viewRtxStats"
        element={<RouteAdapter Component={StatsRtx} />}
      />
      <Route
        path="/viewBillingConf"
        element={<RouteAdapter Component={BillingStatus} />}
      />
      <Route
        path="/viewRESTConf"
        element={<RouteAdapter Component={RESTConfig} />}
      />
      <Route
        path="/viewRADIUSConf"
        element={<RouteAdapter Component={RADIUSConfig} />}
      />
      <Route
        path="/viewOptimizationConf"
        element={<RouteAdapter Component={OptimizationConfig} />}
      />
      {ProfilesConfigViews({ profile }).map(asAdaptedRoute)}
      <Route
        path="/viewDoSConf"
        element={<RouteAdapter Component={DoSConfig} />}
      />
      <Route
        path="/viewManagementInterfaceConf"
        element={<RouteAdapter Component={ManagementInterfaceConfig} />}
      />
      <Route
        path="/viewInterfacesAllConf"
        element={<RouteAdapter Component={LinkState} />}
      />
      <Route
        path="/viewManagementFirewallConf"
        element={<RouteAdapter Component={ManagementFirewallConfig} />}
      />
      <Route
        path="/viewInterfacesBypassConf"
        element={<RouteAdapter Component={Bypass} />}
      />
      <Route
        path="/viewSNMPConf"
        element={<RouteAdapter Component={AdminSNMP} />}
      />
      <Route
        path="/viewUsersAdmin"
        element={<RouteAdapter Component={UsersAdmin} />}
      />
      <Route
        path="/viewGeneralSettingsConfig"
        element={<RouteAdapter Component={GeneralSettings} />}
      />
      {SystemDateAdministrationViews({ profile }).map(asAdaptedRoute)}
      <Route
        path="/viewSoftware"
        element={<RouteAdapter Component={Software} />}
      />
      <Route
        path="/viewLogsKernel"
        element={<RouteAdapter Component={KernelLogs} />}
      />
      <Route
        path="/viewLogsSystem"
        element={<RouteAdapter Component={SystemLogs} />}
      />
      <Route
        path="/viewBackupSave"
        element={<RouteAdapter Component={BackupSave} />}
      />
      <Route
        path="/viewBackupLoad"
        element={<RouteAdapter Component={BackupLoadView} />}
      />
      <Route
        path="/viewSaveSubsAttributes"
        element={<RouteAdapter Component={SaveSubsAttributes} />}
      />
      <Route
        path="/viewLoadSubsAttributes"
        element={<RouteAdapter Component={LoadSubsAttributes} />}
      />
      <Route
        path="/viewStatusInterfacesThroughput"
        element={<RouteAdapter Component={ThroughputStatus} />}
      />
      <Route
        path="/viewStatusInterfacesDataWires"
        element={<RouteAdapter Component={DataWiresConfig} />}
      />
      <Route path="/viewBypass" element={<RouteAdapter Component={Bypass} />} />
      <Route
        path="/viewStatusInterfacesLinkState"
        element={<RouteAdapter Component={LinkState} />}
      />
      <Route
        path="/viewInterfacesDataWiresConf"
        element={<RouteAdapter Component={DataWiresConfig} />}
      />
      <Route
        path="/viewRulesFlow"
        element={<RouteAdapter Component={SubscriberFlows} />}
      />
      <Route
        path="/viewPolicyFlowEdit"
        element={<RouteAdapter Component={PolicyFlowEdit} />}
      />
      <Route
        path="/viewRulesRate"
        element={<RouteAdapter Component={SubscriberRates} />}
      />
      <Route
        path="/viewPolicyRateEdit"
        element={<RouteAdapter Component={PolicyRateEdit} />}
      />
      <Route
        path="/viewRulesMonitor"
        element={<RouteAdapter Component={SubscriberMonitor} />}
      />
      <Route
        path="/viewPolicyMonitorEdit"
        element={<RouteAdapter Component={PolicyMonitorEdit} />}
      />
      <Route
        path="/viewClusterConfiguration"
        element={<RouteAdapter Component={ClusterConfiguration} />}
      />
      <Route
        path="/viewDashboard"
        element={<RouteAdapter Component={DashboardSwitch} />}
      />
      <Route
        path="/viewClusterDashboard"
        element={<RouteAdapter Component={ClusterDashboard} />}
      />
      <Route
        path="/viewLogin"
        element={<RouteAdapter Component={LoginContainer} />}
      />
      <Route
        path="/viewContext"
        element={<RouteAdapter Component={ContextEditor} />}
      />
      <Route path="/:view?" element={<RouteAdapter />} />
    </Routes>
  );
}
